import { MonitoringEventDetailsResizer } from '@modules/monitoring/children/event-details/types/resizer';

export const MONITORING_EVENT_DETAILS_RESIZER: MonitoringEventDetailsResizer = {
  tablesMapSplitSizes: [50, 50],
  tablesSplitSizes: [45, 55]
};
